export default {"src":"/_next/static/media/GOOGL.c37d97d5.svg","height":18,"width":18};